module.exports = __webpack_public_path__ + "561effdbe7312567360bff8d1e90896c.jpg";